import React, { Component } from "react";

import Rating from "../../utils/components/Rating";

import { roundToDecimals } from "../../utils/Utils";

import "../../../styles/components/map/chargerInfo/POICard.scss";
import marker_public from "../../../styles/images/markers/marker_public.svg";

class POICard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="poi-card">
        <img src={this.props.poi.photos || marker_public} alt="" />
        <div className="poi-info">
          <p className="title">{this.props.poi.name}</p>
          <p>
            {this.props.poi.types.length > 0 && this.props.poi.types[0].replace("_", " ")}
            <span className="middot">&middot;</span>
            {this.props.poi.distance > 1000
              ? `${roundToDecimals(this.props.poi.distance / 1000, 2)}km`
              : `${this.props.poi.distance}m`}
          </p>
        </div>
        <div className="rating">
          <Rating value={Math.round(this.props.poi.rating)} />
        </div>
      </div>
    );
  }
}

export default POICard;
